import { ResponsePublication } from 'civil-status/model/publication';
import { PublicationVM } from 'civil-status/view-models/step-form';
import { DateTime } from 'luxon';

const transformTipoDic = (tipoDic?: string): string => {
  if (!tipoDic) {
    return '';
  }

  switch (tipoDic) {
    case '0':
      return 'Entrambi residenti';
    case '1':
      return 'Marito residente';
    case '2':
      return 'Moglie residente';
    case '3':
      return 'Non residenti';
    default:
      return '';
  }
};

export const transformPublicationResponse = (
  response?: ResponsePublication
): PublicationVM | undefined => {
  if (!response) {
    return;
  }

  return {
    year: response.key?.anno,
    number: response.key?.numeroAtto?.toString() || '',
    part: response.key?.regP || '',
    serie: response.key?.regS || '',
    register: response.key?.regR || '',
    date: response.dataDich ? DateTime.fromFormat(response.dataDich, 'dd/MM/yyyy') : null,
    time: response.oraDich ? DateTime.fromFormat(response.oraDich, 'HH.mm.ss') : null,
    residence: transformTipoDic(response.tipoDic),
    nameSurnameGroom: `${response.cognomeSposo || ''} ${response.nomeSposo || ''}`,
    nameSurnameWife: `${response.cognomeSposa || ''} ${response.nomeSposa || ''}`,
    reducedDay: response.giornoPub || 0,
    state: response.stato || '',
    response: response,
  };
};
